export default {
      id: "icon--arrow-right-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "./../Views/Shared/_SvgSprite.cshtml#icon--arrow-right",
      toString: function () {
        return this.url;
      }
    }